<template>
  <List>
    <RecycleScroller
      :style="scrollStyle"
      :items="dataSource"
      :item-size="itemSize"
      :key-field="keyField"
    >
      <div class="ant-list-item" slot-scope="{ item }">
        <slot :item="item" />
      </div>
    </RecycleScroller>
  </List>
</template>
<script lang="ts">
import { RecycleScroller } from 'vue-virtual-scroller'
import { List } from 'ant-design-vue'

// 本组件不考虑横向滚动加载的情况

export default {
  name: 'BuilderList',
  components: {
    RecycleScroller,
    List
  },

  props: {
    dataSource: {
      type: Array,
      required: true
    },
    keyField: {
      // 唯一标识
      type: String,
      default: 'id'
    },
    itemSize: {
      // 预期每一项的高度
      type: Number,
      default: null
    },
    scrollStyle: {
      // 通常限定高度 例如 "height: 400px"
      type: [Object, String]
    }
  }
}
</script>
<style lang="less">
.spin-loading {
  position: absolute;
  bottom: 40px;
  width: 100%;
  text-align: center;
}
.hide-scroll .vue-recycle-scroller {
  &::-webkit-scrollbar-thumb {
    background: transparent !important;
  }
}
</style>
